import { useDraggable } from '@dnd-kit/core';
import {
  createFootprintShapeDragData,
  footprintShapeDraggableId
} from 'utils/footprint-shape-drag';

type FootprintShapeFillProps = Readonly<{
  shapeIndex: number;
  pathD: string;
  interactive: boolean;
  readOnly: boolean;
  highlighted: boolean;
  onDoubleClick?: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onMouseMove: (e: React.MouseEvent) => void;
}>;

export default function FootprintShapeFill({
  shapeIndex,
  pathD,
  interactive,
  readOnly,
  highlighted,
  onDoubleClick,
  onMouseEnter,
  onMouseLeave,
  onMouseMove
}: FootprintShapeFillProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: footprintShapeDraggableId(shapeIndex),
    data: createFootprintShapeDragData(shapeIndex),
    disabled: !interactive
  });

  const handleMouseDown = (e: React.MouseEvent<SVGPathElement>) => {
    if (e.button !== 0) return;
    e.stopPropagation();
    listeners?.onMouseDown?.(e);
  };

  return (
    <path
      ref={setNodeRef as (element: SVGPathElement | null) => void}
      d={pathD}
      fill={
        highlighted && interactive
          ? 'rgba(59, 130, 246, 0.12)'
          : 'rgba(59, 130, 246, 0.06)'
      }
      stroke='#3b82f6'
      strokeWidth={1.5}
      strokeDasharray='6 4'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{
        pointerEvents: interactive ? 'auto' : 'none',
        cursor: isDragging ? 'grabbing' : 'grab',
        opacity: readOnly ? 0.5 : 1
      }}
      {...attributes}
      {...listeners}
      onMouseDown={handleMouseDown}
      onDoubleClick={onDoubleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseMove={onMouseMove}
    />
  );
}
